<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-md-0 mb-4">
            <h5 class="text-primary d-inline">
              <i class="fas fa-user" /> Cliente
            </h5>

            <b-form-group label class="mt-2">
              <b-form-radio-group
                v-model="form.unidentified_client.value"
                :options="unidentified_client_options"
                name="radios-btn-primary"
                style="cursor: pointer"
              ></b-form-radio-group>
            </b-form-group>
            <div v-if="form.unidentified_client.value == 0">
              <client-search
                v-model="form.client_id.value"
                :name="form.name.value"
              />
              <client-stats
                :client_id="form.client_id.value"
                @due_day="onSetDueDays($event)"
              />
            </div>
          </div>
          <div class="offset-md-2 col-md-4">
            <h5 class="text-primary"><i class="fas fa-user-tie" /> Vendedor</h5>
            <salesman-search
              v-model="form.salesman_id.value"
              :name="form.salesman_name.value"
            />
          </div>
        </div>
      </div>
    </div>

    <br />
    <br />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <template>
              <order-products
                ref="orderProducts"
                v-model="products"
                :priceType="priceType"
                :hasPaymentMethodOnTerm="hasPaymentMethodOnTerm"
              />
            </template>

            <br />
            <br />

            <template v-if="hasProducts">
              <div class="container-fluid">
                <template v-for="(row, index) in products">
                  <div
                    class="row row-list-product align-items-center"
                    :key="index"
                  >
                    <div class="col-12 col-md-4 mb-md-0 mb-3">
                      <span class="align-middle">{{ row.product }} </span>
                      <small class="align-middle text-muted"
                        >#{{ row.base_sku_id }}</small
                      >
                    </div>
                    <br />

                    <div
                      class="col-12 col-md-2 mb-md-0 mb-3 d-flex justify-content-between justify-content-md-end"
                    >
                      <div class="d-inline d-md-none">
                        <small class="text-muted">Quant:</small>
                      </div>
                      <div>{{ row.quantity | decimal(3) }}</div>
                    </div>

                    <div
                      class="col-12 col-md-2 mb-md-0 mb-3 d-flex justify-content-between justify-content-md-end"
                    >
                      <div class="d-inline d-md-none">
                        <small class="text-muted">Preço:</small>
                      </div>
                      <div>{{ row.price | decimal }}</div>
                    </div>

                    <div
                      class="col-12 col-md-2 mb-md-0 mb-3 d-flex justify-content-between justify-content-md-end"
                    >
                      <div class="d-inline d-md-none">
                        <small class="text-muted">Total:</small>
                      </div>
                      <div>
                        <b>{{ (row.quantity * row.price) | decimal }}</b>
                      </div>
                    </div>
                    <br />

                    <div class="col-12 col-md-2 d-flex justify-content-around">
                      <div>
                        <button
                          class="btn btn btn-light"
                          @click="setProductUpdate(index)"
                        >
                          <i class="text-info fas fa-pen" />
                        </button>
                      </div>
                      <div>
                        <button
                          style="margin-left: 10px"
                          class="btn btn btn-light"
                          @click="deleteProduct(index)"
                        >
                          <i class="text-info fas fa-trash" />
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>

            <template v-else>
              <span class="text-info"
                >Utilize o formulario acima para adicionar produtos...</span
              >
              <br />
              <br />
            </template>
          </div>
        </div>
      </div>
    </div>

    <br />

    <div class="row">
      <div class="col-md-6 order-2 order-md-1 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <i class="fas fa-cash-register" /> Pagamento
                </h5>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-12 mb-5">
                <order-payments
                  v-model="payments"
                  :operation="operation"
                  :orderTotal="orderTotal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 order-1 order-md-2 mb-4">
        <div class="card">
          <div class="card-body">
            <order-totals
              ref="OrderTotals"
              :operation="operation"
              :productsTotal="productsTotal"
              :discount="form.discount.value"
              :addition="form.addition.value"
              :shipping="form.shipping.value"
              :orderTotal="orderTotal"
              :maxDiscountAllowed="maxDiscountAllowed"
              :blockByMaximunDiscount="blockByMaximunDiscount"
              @discountUpdated="onDiscountUpdated($event)"
              @additionUpdated="onAdditionUpdated($event)"
              @shippingUpdated="onShippingUpdated($event)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 order-2 order-md-1">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <i class="far fa-comment-alt"></i>
                  Observações
                </h5>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-textarea v-model="form.notes.value" rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />

    <error-handler :error="error" />

    <b-alert
      :show="alertData.isVisible"
      fade
      variant="danger"
      @dismissed="alertData.isVisible = false"
      dismissible
      >{{ alertData.message }}</b-alert
    >

    <div class="row">
      <div class="col-md-12 text-right">
        <router-link to="/vendas">
          <button
            role="button"
            class="mb-2 bl-2 d-block d-md-inline btn btn-outline-primary btn-block-sm-only"
            type="button"
            style="margin-left: 5px"
          >
            <i class="fas fa-times"></i> Cancelar
          </button>
        </router-link>
        <button
          v-if="
            form.status.value == 'd' ||
            (form.status.value == null && operation == 1)
          "
          role="button"
          class="mb-2 bl-2 d-block d-md-inline btn btn-primary btn-block-sm-only"
          style="margin-left: 5px"
          @click="handleStore('draft')"
        >
          <i class="fas fa-edit"></i> Salvar Rascunho
        </button>
        <button
          v-if="
            form.status.value != 'o' &&
            form.status.value != 'c' &&
            operation == 1
          "
          role="button"
          class="mb-2 bl-2 d-block d-md-inline btn btn-primary btn-block-sm-only"
          style="margin-left: 5px"
          @click="handleStore('proposal')"
        >
          <i class="fas fa-file-invoice"></i> Salvar em Orçamentos
        </button>
        <button
          v-if="form.status.value != 'o' && form.status.value != 'c'"
          role="button"
          :class="[
            'mb-2 bl-2 d-block d-md-inline btn btn-block-sm-only',
            operation == 1 ? 'btn-success' : 'btn-danger',
          ]"
          style="margin-left: 5px"
          @click="handleStore('order')"
        >
          <i class="fas fa-check mr-1"></i>
          <span v-if="operation == 1">Confirmar Venda</span>
          <span v-else>Confirmar Devolução</span>
        </button>
      </div>
    </div>
    <emit-order-bill-form
      ref="emitOrderBillForm"
      @hide="showOrderSuccessModal()"
    />
    <order-success-modal
      ref="orderSuccessModal"
      @return="returnToOrderView()"
      @newOrder="handleNewOrder()"
    />
  </div>
</template>

<script>
import Form from "@/mixins/Form.js";
import Filters from "@/mixins/Filters.js";
import moment from "moment";
import OrderProducts from "@/components/sections/OrderProducts";
import OrderPayments from "@/components/sections/OrderPayments";
import OrderTotals from "@/components/sections/OrderTotals";
import PersonCard from "@/components/sections/PersonCard";
import ClientSearch from "@/components/ClientSearch";
import SalesmanSearch from "@/components/SalesmanSearch";
import ClientStats from "@/components/sections/person/ClientStats";
import VueRouter from "@/router";
import EmitOrderBillForm from "@/components/forms/EmitOrderBillForm.vue";
import orderSuccessModal from "@/components/order/sections/OrderSuccessModal";

function initialState() {
  return {
    showNotes: false,
    form: new Form({
      unidentified_client: {
        default: 1,
      },

      client_id: {
        alias: "Cliente",
        validate: null,
        value: null,
      },

      name: {},

      salesman_id: {},

      salesman_name: {},

      addition: {
        value: 0,
      },

      discount: {
        value: 0,
      },

      shipping: {
        value: 0,
      },

      notes: {
        value: null,
      },

      status: {},

      onSetDueDays: {
        value: 0,
      },
    }),

    products: [],

    payments: [
      {
        payment_method: 1,

        value: null,

        due_days: 30,

        due_date: moment().add(30, "d").format("YYYY-MM-DD"),
      },
    ],

    error: null,

    unidentified_client_options: [
      {
        value: 1,
        text: "Consumidor Final",
      },
      {
        value: 0,
        text: "Informar Cliente",
      },
    ],

    selectedPerson: null,

    alertData: {
      isVisible: false,
      message: null,
    },

    orderStatus: {
      draft: {
        url: "api/order/store",
        msg: "Salvo como Rascunho!",
      },

      proposal: {
        url: "api/order/storeproposal",
        msg: "Orçamento Salvo",
      },

      order: {
        url: "api/order/storeorder",
        msg: "Venda Concluida",
      },

      cancel: {
        url: "api/order/storecancel",
        msg: "Venda Cancelada",
      },
    },

    lastOrderStored: {},
  };
}

export default {
  components: {
    OrderProducts,
    OrderPayments,
    OrderTotals,
    PersonCard,
    ClientSearch,
    SalesmanSearch,
    ClientStats,
    EmitOrderBillForm,
    orderSuccessModal,
  },

  props: {
    id: {},
    operation: {},
  },

  data: function () {
    return initialState();
  },

  async created() {
    //await this.reset();
  },

  mounted() {
    if (!this.id) {
      this.setDefaultSalesman();
    }
  },

  computed: {
    isInsert() {
      return !this.id;
    },

    defaultSalesman() {
      return this.$store.state.user.salesman;
    },

    method() {
      return this.id ? "put" : "post";
    },

    unidentifiedClient() {
      return this.form.unidentified_client.value;
    },

    url() {
      let url = process.env.BASE_URL + "erp/order/order";

      if (this.id) {
        url = url + "/" + this.id;
      }

      return url;
    },

    hasProducts() {
      return this.products.length > 0;
    },

    productsTotal() {
      return (
        Math.round(
          this.products.reduce(
            (total, row) =>
              total +
              Math.round(parseFloat(row.quantity * row.price * 100)) / 100,
            0
          ) * 100
        ) / 100
      );
    },

    orderDiscountPercent() {
      if (this.productsTotal == 0) {
        return 0;
      } else {
        return (
          Math.round(
            (this.form.discount.value / this.productsTotal) * 100 * 100
          ) / 100
        );
      }
    },

    pricePolicy() {
      return this.$store.state.company.product_payment_policy;
    },

    priceType() {
      if (this.pricePolicy == 2) {
        if (this.hasPaymentMethodOnTerm) {
          return "price_payment_on_terms";
        } else {
          return "price_payment_immediate";
        }
      }

      return "price";
    },

    hasPaymentMethodOnTerm() {
      let filtered = this.payments.filter((row) => {
        if (
          (row.payment_method == 2 &&
            this.$store.state.company
              .order_apply_price_payment_on_terms_payment_method_2 == 1) ||
          (row.payment_method == 3 &&
            this.$store.state.company
              .order_apply_price_payment_on_terms_payment_method_3 == 1) ||
          (row.payment_method == 4 &&
            this.$store.state.company
              .order_apply_price_payment_on_terms_payment_method_4 == 1) ||
          (row.payment_method == 5 &&
            this.$store.state.company
              .order_apply_price_payment_on_terms_payment_method_5 == 1) ||
          (row.payment_method == 15 &&
            this.$store.state.company
              .order_apply_price_payment_on_terms_payment_method_15 == 1)
        ) {
          return row;
        }
      });

      return filtered.length > 0;
    },

    maxDiscountAllowed() {
      const paymentMethods = [
        ...new Set(this.payments.map((row) => row.payment_method)),
      ];

      return Math.min(
        ...paymentMethods.map((val) =>
          parseFloat(
            this.$store.state.company[
              "order_max_discount_payment_method_" + val
            ]
          )
        )
      );
    },

    blockByMaximunDiscount() {
      if (
        this.$store.state.company.order_enable_max_discount == 0 ||
        this.$store.state.user.is_master_user == 1
      ) {
        return false;
      }

      return this.orderDiscountPercent > this.maxDiscountAllowed;
    },

    orderTotal() {
      return (
        Math.round(
          (parseFloat(this.productsTotal) +
            parseFloat(this.form.addition.value) -
            parseFloat(this.form.discount.value) +
            parseFloat(this.form.shipping.value)) *
            100
        ) / 100
      );
    },
  },

  watch: {
    unidentifiedClient(newValue) {
      if (newValue == 0) {
        this.form.client_id.validate = {
          required: true,
        };
      } else {
        this.form.client_id.value = null;
        this.form.client_id.validate = null;
      }
    },
  },

  methods: {
    async reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },

    async loadOrder(id) {
      this.id = id;

      return await new Promise((resolve, reject) => {
        axios
          .post("../../../api/order/edit/" + this.id)
          .then((response) => {
            // change values

            this.form.setValues(response.data.order);

            if (response.data.person) {
              this.form.name.value = response.data.person.name;
            }

            if (response.data.salesman) {
              this.form.salesman_id.value = response.data.salesman.id;
              this.form.salesman_name.value = response.data.salesman.name;
            }

            this.$refs.orderProducts.setProductsData(
              response.data.productsData
            );

            this.products = response.data.orderProducts;

            this.payments = response.data.orderBills;

            resolve();
          })
          .catch((error) => {
            //this.error = error;
            reject();
          });
      });
    },

    async loadProductsFromOrder(id) {
      return await new Promise((resolve, reject) => {
        axios
          .post("../../api/order/edit/" + id)
          .then((response) => {
            // change values
            this.form.setValues(response.data.order);

            this.form.status.value = null;

            if (response.data.person) {
              this.form.name.value = response.data.person.name;
            }

            if (response.data.salesman) {
              this.form.salesman_id.value = response.data.salesman.id;
              this.form.salesman_name.value = response.data.salesman.name;
            }

            this.$refs.orderProducts.setProductsData(
              response.data.productsData
            );

            this.products = response.data.orderProducts;

            //this.payments = response.data.orderBills;

            resolve();
          })
          .catch((error) => {
            //this.error = error;
            reject();
          });
      });
    },

    setDefaultSalesman() {
      if (this.defaultSalesman) {
        this.form.salesman_id.value = this.defaultSalesman.id;
        this.form.salesman_name.value = this.defaultSalesman.name;
      }
    },

    openEmitOrderBillForm(id) {
      this.$refs.emitOrderBillForm.open(id, "orderStore");
    },

    handleStore(orderStatus) {
      if (this.form.isValid()) {
        this.store(orderStatus);
      } else {
        this.showFormErrorMsg();
      }
    },

    store(orderStatus) {
      this.$store.commit("showLoading");

      axios({
        method: this.method,
        url: this.url,
        data: this.getAttributes(orderStatus),
      })
        .then((response) => {
          this.$store.commit("hideLoading");
          this.processStoreSuccess(orderStatus, response.data);
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.processStoreError(error);
        });
    },

    processStoreSuccess(orderStatus, order) {
      this.lastOrderStored = order;
      if (orderStatus == "order") {
        this.form.status.value = "o";
        this.openEmitOrderBillForm(order.id, "orderStore");
        mixpanel.track("orderStored");
      } else {
        this.showOrderSuccessModal(order);
      }
    },

    showOrderSuccessModal() {
      if (this.isInsert) {
        this.$refs.orderSuccessModal.show(this.lastOrderStored);
      } else {
        this.$router.push({
          path: "/vendas",
        });
      }
    },

    processStoreError(error) {
      this.error = error;
    },

    showFormErrorMsg() {
      this.alertData.message = this.form.getFirstErrorMsg();
      this.alertData.isVisible = true;
    },

    getAttributes(orderStatus) {
      var attributes = this.form.getValues();

      attributes.orderStatus = orderStatus;

      attributes.operation_id = this.operation;

      attributes.order_products = JSON.parse(JSON.stringify(this.products));
      attributes.order_bills = JSON.parse(JSON.stringify(this.payments));

      if (this.operation == 2) {
        attributes.order_products = attributes.order_products.map((row) => {
          row.quantity = row.quantity * -1;
          return row;
        });

        attributes.order_bills = attributes.order_bills.map((row) => {
          row.value = row.value * -1;
          return row;
        });

        attributes.addition = attributes.addition * -1;
        attributes.discount = attributes.discount * -1;
        attributes.shipping = attributes.shipping;
      }

      return attributes;
    },

    deleteProduct(index) {
      this.form.discount.value = 0;
      this.discountPercent = 0;

      this.$delete(this.products, index);
    },

    setProductUpdate(index) {
      this.$refs.orderProducts.setProductUpdate(index);
    },

    onDiscountUpdated(value) {
      this.form.discount.value = value;
    },

    onAdditionUpdated(value) {
      this.form.addition.value = value;
    },

    onShippingUpdated(value) {
      this.form.shipping.value = value;
    },

    onSetDueDays(event) {
      this.form.onSetDueDays.value = event;
    },

    handleNewOrder() {
      this.reset();
      this.setDefaultSalesman();
      this.$refs.OrderTotals.reset();
      window.scrollTo(0, 0);
    },

    returnToOrderView() {
      this.$router.push("/vendas");
    },
  },
};
</script>

<style>
.row-list-product {
  padding-top: 1rem;
  padding-bottom: 1rem;
  /*border-top: dashed 1px gray;*/
  border-bottom: dashed 1px rgba(0, 0, 0, 0.125);
}

.row-list-first {
  padding-top: 1rem;
  /*border-top: dashed 1px rgba(0, 0, 0, 0.125);*/
  border-top: dashed 1px rgba(0, 0, 0, 0.125);
}

@media (max-width: 575px) {
  .btn-block-sm-only {
    display: flex;
    width: 100%;
  }
}
</style>
